import { render, staticRenderFns } from "./not-find-event.vue?vue&type=template&id=6f5fb126&"
import script from "./not-find-event.vue?vue&type=script&lang=js&"
export * from "./not-find-event.vue?vue&type=script&lang=js&"
import style0 from "./not-find-event.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/not-find-event/not-find-event.vue
// module id = 338
// module chunks = 0